((app, ng) => {

    app.component("accountRelationships",
        {
            templateUrl: "/App/Client/Case/Accounts/AccountRelationships/account-relationships.html",
            controller: accountRelationshipsController,
            bindings: {
                client: "<",
                account: "<",
            }
        });

    function accountRelationshipsController(caseModalService) {
        const $ctrl = this;

        const openEditRelationships = (relationships, $event) => {
            caseModalService.openEditAccountRelationships(relationships, $ctrl.client, $ctrl.account, $event);
        }

        ng.extend($ctrl,
            {
                openEditRelationships,
            });

        $ctrl.$onInit = () => {
            $ctrl.relationshipMap = $ctrl.account.Relationships.reduce((map, obj) => {
                switch (obj.AccountRelationshipType) {
                    case "Beneficiary":
                        if (!map.Beneficiaries) map.Beneficiaries = [];
                        map.Beneficiaries.push(obj);
                        break;
                    case "ContingentBeneficiary":
                        if (!map.ContingentBeneficiaries) map.ContingentBeneficiaries = [];
                        map.ContingentBeneficiaries.push(obj);
                        break;
                    default:
                        map[obj.AccountRelationshipType] = obj;
                        break;
                }
                return map;
            },
                {});
        }
    }

})(window.app, window.angular);